module.exports = __webpack_public_path__ + "static/media/testImage9.aefd67a2.png";